<template>
  <div id="videoList" align="center">
    <div class="video_list" v-loading="loading">
      <div class="video_item" v-for="(item, i) in list" @click="videoDetailHandler(item.tid)">
        <el-image class="course_cover_image" fit="cover" :src="item.cover_image_url"></el-image>
        <div class="course_cover_title">{{item.name}}</div>
        <div class="course_cover_detail"><span>考试时间60分钟</span><span style="margin-left: 20px;">{{item.views_count}}人参加考试</span>
        </div>
      </div>
    </div>
    <div class="video_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[20, 40, 60, 100]"
        :page-size="20"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>

  import {APIRequest} from '@/api/api';

  export default {
    data() {
      return {
        loading: true,
        page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
        size: this.$route.query.size ? parseInt(this.$route.query.size) : 20,
        sort_type: 3,
        total: 0,
        list: []
      }
    },
    created() {
      this.fetchList();
    },
    methods: {
      fetchList() {
        let self = this;
        let params = {
          page: self.page,
          size: self.size,
          sort_type: self.sort_type,
        };
        self.loading = true;
        APIRequest('getExamList', params, false).then(res => {
          self.loading = false;
          self.total = parseInt(res.data.total);
          self.list = res.data.data;
        }, err => {
          self.loading = false;
        });
      },
      handleSizeChange(size) {
        this.size = size;
        this.fetchList();
        this.$router.replace({ path: '/exam_list', query: {page: this.page, size: this.size} });
      },
      handleCurrentChange(page) {
        this.page = page;
        this.fetchList();
        this.$router.replace({ path: '/exam_list', query: {page: this.page, size: this.size} });
      },
      videoDetailHandler(tid) {
        this.$router.replace('/exam_detail?tid=' + tid);
      }
    },
  }
</script>

<style>
  .video_list {
    position: relative;
    text-align: left;
    min-width: 1040px;
    max-width: 1300px;
    min-height: 200px;
    margin: 20px 200px 20px 200px;
    padding: 0;
    display: block;
  }

  .video_list .video_item {
    position: relative;
    width: 240px;
    padding: 0 12px 16px 0;
    margin: 10px 10px 20px 10px;
    display: inline-block;
    box-sizing: border-box;
    vertical-align: top;
    cursor: pointer;
  }

  .video_list .video_item .course_cover_image {
    width: 240px;
    height: 180px;
    display: block;
  }

  .video_list .video_item .course_cover_title {
    width: 240px;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    display: block;
    overflow: hidden;
  }

  .video_list .video_item .course_cover_detail {
    width: 250px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    display: block;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/QuestionsPaper/List.vue